<template lang="pug">
div.root(:style="{ overflow: hidden ? 'hidden' : 'auto'}")
  div(class="container" id="container" v-on:[scaleEvent].stop.capture.prevent="viewScale" @mouseenter="setCrossPosition" @mouseleave="removeCross" @mousemove.capture="movePannel" @contextmenu.prevent :style="{transform: `scale(${viewTransfrom.scale}) translate(${viewTransfrom.tX}px,${viewTransfrom.tY}px)`}")
    img(:src="imageReformat(src)" ref="img" @load="imgLoad" :style="{ maxWidth: hidden ? '100%' : 'none', height: imgHeight, width: imgWidth }")
    div#lineX(v-show="!mode && this.painter && [2].includes(this.painter.type)")
    div#lineY(v-show="!mode && this.painter && [2].includes(this.painter.type)")
    div.mask-panel
      svg(:viewBox="`0 0 ${size[0]} ${size[1]}`")
        template(v-for="anno in annos")
          g(v-if="anno.type===0" @click="$emit('annoClick', anno.id)" @mouseenter="setCurAnno(anno.id)" @mouseout="cancelCurAnno(anno.id)")
            circle(
              v-for="pt in anno.data[0]"
              :cx="pt[0]"
              :cy="pt[1]"
              :fill="getColor(anno.cat)"
              :r="7/viewTransfrom.scale"
            )
          polyline(
            v-else-if="anno.type===1"
            :points="anno.data[0].reduce((str, v) => `${str} ${v[0]},${v[1]}`)"
            :stroke="getColor(anno.cat)"
            :stroke-width="5/viewTransfrom.scale"
            fill="none"
            style="pointer-events:stroke;"
            @click="$emit('annoClick', anno.id)"
            @mouseenter="setCurAnno(anno.id)"
            @mouseout="cancelCurAnno(anno.id)"
          )
          circle(
            v-else-if="anno.type===2"
            opacity="0.5"
            :cx="anno.data[0][0][0]/2 + anno.data[0][1][0]/2"
            :cy="anno.data[0][0][1]/2 + anno.data[0][1][1]/2"
            :fill="mode ? '#FFAABB' : getColor(anno.cat)"
            :r="Math.min(15, Math.abs(anno.data[0][1][0] - anno.data[0][0][0])/2, Math.abs(anno.data[0][1][1] - anno.data[0][0][1])/2)"
            @click="$emit('annoClick', anno.id)"
            @mouseenter="setCurAnno(anno.id)"
            @mouseout="cancelCurAnno(anno.id)"
          )
          path(
            v-else
            :d="anno.data.map(v => `M${v.map(p => `${p[0]},${p[1]}`).join('L')}z`).join('')"
            :fill="getColor(anno.cat)"
            :fill-opacity="mode ? 0.5 : 0"
            :stroke-width="(mode?2:0)/ viewTransfrom.scale"
            stroke="white"
            fill-rule="evenodd"
            @click="$emit('annoClick', anno.id)"
            @mouseenter="setCurAnno(anno.id)"
            @mouseout="cancelCurAnno(anno.id)"
          )
    div.mask-panel.ignore(v-if="!!mode")
      div.crop-box(v-for="anno in boxAnnos" :style="[getBbox(anno), {borderColor: getColor(anno.cat)}]")
      div.crop-box(v-for="anno in outlineAnnos" :style="[getBbox(anno), {borderColor: getColor(anno.cat) + '6'}]") {{anno.outline===2?anno.title:''}}
      div.crop-box.main(v-if="curAnno" :style="getBbox(curAnno)") {{curAnno.type!==0 ? curAnno.title : ''}}
    div.mask-panel(v-if="!mode")
      svg(
        class="painter"
        @mousedown.exact.stop="addPoint"
        @mousedown.shift.stop="addPointNear"
        @mousedown.ctrl.stop="addSeg"
        @mousemove.stop="movePoint"
      )
        path(
          v-if="painter.type===1"
          :d="painter.data.map(v => `M${v.map(p => `${p[0]},${p[1]}`).join('L')}`).join('')"
          :stroke-width="1/viewTransfrom.scale"
          fill="none"
          stroke="white"
        )
        template(v-else-if="painter.type===2")
          rect(
            v-for="rect in painter.data.filter(v => v.length > 1)"
            :x="Math.min(rect[0][0], rect[1][0])"
            :y="Math.min(rect[0][1], rect[1][1])"
            :width="Math.abs(rect[1][0]-rect[0][0])"
            :height="Math.abs(rect[1][1]-rect[0][1])"
            :stroke-width="2/viewTransfrom.scale"
            fill="none"
            stroke="#1e90ff"
          )
        path(
          v-else-if="painter.type===3"
          :d="painter.data.map(v => `M${v.map(p => `${p[0]},${p[1]}`).join('L')}z`).join('')"
          :stroke-width="1/viewTransfrom.scale"
          fill="#512da8a6"
          stroke="white"
          fill-rule="evenodd"
        )
        g(v-for="(grp, gIdx) in painter.data")
          circle(
            v-for="(pt, idx) in grp"
            :index="`${gIdx}|${idx}`"
            :cx="pt[0]"
            :cy="pt[1]"
            :fill="idx===0?'#f008':'#0008'"
            :r="4/viewTransfrom.scale"
            @mousedown.stop="getPoint"
            @mouseup.stop="dropPoint"
            @click.alt.exact.stop="delPoint"
          )
</template>
<script>
import { imageReformat } from '@/utils/util';

export default {
  name: 'AnnoPanel',
  data: function() {
    return {
      curAnno: null,
      viewTransfrom: { scale: 1, tX: 0, tY: 0 },
      painter: { type: 0, data: [] },
      size: [100, 100],
      imgHeight: 'auto',
      imgWidth: 'auto',
      retryCnt: 10,
    };
  },
  props: {
    src: String,
    mode: Number,
    annos: Array,
    maskColor: String,
    height: String,
    scalable: Boolean,
    separable: Boolean,
    hidden: {
      type: Boolean,
      default: true,
      required: false,
    },
    annoEnable: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    boxAnnos: function() {
      return this.annos.filter(v => v.type === 2);
    },
    outlineAnnos: function() {
      return this.annos.filter(v => !!v.outline);
    },
    testHeight: function() {
      if (this.$el) return this.$el.offsetWidth;
      return 100;
    },
    scaleEvent: function() {
      return this.scalable ? 'mousewheel' : null;
    },
  },
  created() {
    const code = ['4', 'a', '7', 'd'];
    this.typeColors = [];
    for (var a of code) for (var b of code) for (var c of code) this.typeColors.push('#' + c + b + a);
    this.typeColors[0] = '#a4d';
  },
  mounted: function() {},
  methods: {
    imageReformat,
    imgLoad: function() {
      this.size = [this.$refs.img.naturalWidth, this.$refs.img.naturalHeight];
      const rootElement = document.getElementsByClassName('root').item(0);
      if (rootElement) {
        const ratio = Math.min(
          window.getComputedStyle(rootElement).width.replace('px', '') / this.size[0],
          window.getComputedStyle(rootElement).height.replace('px', '') / this.size[1],
          1,
        );
        if (ratio <= 0.001 && this.retryCnt-- > 0) {
          setTimeout(() => {
            this.imgLoad();
          }, 100);
          return;
        }
        this.imgWidth = this.hidden ? `${this.size[0] * ratio}px` : 'auto';
        this.imgHeight = this.hidden ? `${this.size[1] * ratio}px` : 'auto';
      }
    },
    reset: function() {
      this.viewTransfrom = { scale: 1, tX: 0, tY: 0 };
    },
    getColor: function(seq) {
      if (seq < 0) {
        let map = ['', '#CF9', '#FF6', '#F66', '#669', 'transparent'];
        return this.mode ? map[0 - seq] : this.maskColor;
      }
      return this.mode ? this.typeColors[seq % 64] : this.maskColor;
    },
    getBbox: function(anno) {
      const xArray = anno.data.reduce((r, v) => [...r, ...v.map(v => v[0])], []);
      const yArray = anno.data.reduce((r, v) => [...r, ...v.map(v => v[1])], []);
      const xMin = Math.min(...xArray);
      const yMin = Math.min(...yArray);
      const width = Math.max(0, ...xArray) - xMin;
      const height = Math.max(0, ...yArray) - yMin;

      const styleSheet = {
        top: (yMin * 100) / this.size[1] + '%',
        left: (xMin * 100) / this.size[0] + '%',
        width: (width * 100) / this.size[0] + '%',
        height: (height * 100) / this.size[1] + '%',
      };
      if ([0, 2].includes(anno.type)) {
        Object.assign(styleSheet, {
          'border-width': '2px',
        });
      }
      return styleSheet;
    },
    setCurAnno: function(annoId) {
      this.curAnno = this.annos.find(v => v.id === annoId);
    },
    cancelCurAnno: function(annoId) {
      if (this.curAnno.id === annoId) this.curAnno = null;
    },
    viewScale: function(event) {
      if (!this.scalable) return;
      const [mouseX, mouseY] = [event.offsetX, event.offsetY];
      const scale = Math.min(20, Math.max(this.viewTransfrom.scale + event.wheelDelta / 1200, 1));
      let tX = this.viewTransfrom.tX + ((mouseX + this.viewTransfrom.tX) * (this.viewTransfrom.scale - scale)) / scale;
      let tY = this.viewTransfrom.tY + ((mouseY + this.viewTransfrom.tY) * (this.viewTransfrom.scale - scale)) / scale;
      if (scale === 1) [tX, tY] = [0, 0];
      this.viewTransfrom = { scale, tX, tY };
      const lineX = document.getElementById('lineX');
      const lineY = document.getElementById('lineY');
      if (lineX) {
        lineX.style.borderTop = `${1.8 / this.viewTransfrom.scale}px dashed #000`;
      }
      if (lineY) {
        lineY.style.borderLeft = `${1.8 / this.viewTransfrom.scale}px dashed #000`;
      }
    },
    addPoint: function(event) {
      if (event.button !== 0 || !this.annoEnable) return;
      const pt = [event.offsetX, event.offsetY];
      const length = this.painter.data.length;
      // 矩形只能画两点
      if (this.painter && this.painter.type === 2 && this.painter.data[length - 1].length > 1) return;
      this.painter.data[length - 1].push(pt);
      this.activePoint = pt;
    },
    addPointNear: function(event) {
      if (event.button !== 0 || !this.annoEnable) return;
      const pt = [event.offsetX, event.offsetY];
      let minVal = [0, 0, Infinity];
      this.painter.data.some((ptArr, gIdx) => {
        if (this.painter.type === 2 && ptArr.length > 1) return;
        ptArr.some((v, i) => {
          const next = ptArr.length < i + 2 ? 0 : i + 1;
          const dis = this.pointToSegDist(pt, ptArr[i], ptArr[next]);
          // TODO: compare cos
          if (minVal[2] > dis) minVal = [gIdx, i + 1, dis];
        });
      });
      if (this.painter.type < 2) {
        this.painter.data[minVal[0]].push(pt);
        this.activePoint = pt;
        return;
      }
      if (this.painter.type === 2 && this.painter.data[minVal[0]].length > 1) return;
      this.painter.data[minVal[0]].splice(minVal[1], 0, pt);
      this.activePoint = pt;
    },
    addSeg: function(event) {
      if (event.button !== 0 || !this.separable || !this.annoEnable) return;
      const mX = event.offsetX;
      const mY = event.offsetY;
      const length = this.painter.data.push([[mX, mY]]);
      this.activePoint = this.painter.data[length - 1][0];
    },
    getPoint: function(event) {
      if (event.button !== 0 && !this.annoEnable) return;
      const [gIdx, idx] = event.target.attributes.index.value.split('|');
      this.activePoint = this.painter.data[gIdx][idx];
    },
    movePoint: function(event) {
      this.setCrossPosition(event);
      if (this.activePoint && this.annoEnable) {
        this.activePoint[0] = event.offsetX;
        this.activePoint[1] = event.offsetY;
        this.$forceUpdate();
      }
    },
    movePannel: function(event) {
      if (event.buttons == 2 && this.scalable) {
        this.viewTransfrom = {
          scale: this.viewTransfrom.scale,
          tX: this.viewTransfrom.tX + event.movementX,
          tY: this.viewTransfrom.tY + event.movementY,
        };
      }
    },
    dropPoint: function(event) {
      if (!this.annoEnable) return;
      if (event.button === 0) this.activePoint = null;
      else if (event.button === 2) this.delPoint(event);
    },
    delPoint: function(event) {
      if (!this.annoEnable) return;
      const [gIdx, idx] = event.target.attributes.index.value.split('|');
      this.painter.data[gIdx].splice(idx, 1);
      if (this.painter.data[gIdx].length === 0) this.painter.data.splice(gIdx, 1);
    },
    setPainter: function(painter) {
      const ratio = this.$refs.img.width / this.$refs.img.naturalWidth;
      painter.data = painter.data.map(v => v.map(v => v.map(v => v * ratio)));
      this.painter = painter;
    },
    getPainter: function() {
      const ratio = this.$refs.img.naturalWidth / this.$refs.img.width;
      const data = this.painter.data.map(v => v.map(v => v.map(v => v * ratio)));
      return { ...this.painter, data };
    },
    pointToSegDist([x, y], [x0, y0], [x1, y1]) {
      const cross = (x1 - x0) * (x - x0) + (y1 - y0) * (y - y0);
      if (cross <= 0) return (x - x0) * (x - x0) + (y - y0) * (y - y0);
      const d2 = (x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0);
      if (cross >= d2) return (x - x1) * (x - x1) + (y - y1) * (y - y1);
      const r = cross / d2;
      const px = x0 + (x1 - x0) * r;
      const py = y0 + (y1 - y0) * r;
      return (x - px) * (x - px) + (py - y) * (py - y);
    },
    setCrossPosition: function(e) {
      const lineX = document.getElementById('lineX');
      const lineY = document.getElementById('lineY');
      if (lineX) {
        lineX.style.width = '100%';
        lineX.style.height = '0px';
        lineX.style.borderTop = `${1.8 / this.viewTransfrom.scale}px dashed #000`;
        lineX.style.position = 'absolute';
        lineX.style.top = e.offsetY + 'px';
        lineY.style.height = '100%';
      }
      if (lineY) {
        lineY.style.width = '1px';
        lineY.style.borderLeft = `${1.8 / this.viewTransfrom.scale}px dashed #000`;
        lineY.style.position = 'absolute';
        lineY.style.left = e.offsetX + 'px';
        lineY.style.top = '0px';
      }
    },
    removeCross() {
      const lineX = document.getElementById('lineX');
      const lineY = document.getElementById('lineY');
      if (lineX) {
        lineX.style.width = '0px';
      }
      if (lineY) {
        lineY.style.width = '0px';
        lineY.style.borderLeft = '0px dashed #000';
      }
    },
  },
};
</script>
<style scoped lang="stylus">
.root
  //overflow auto
  display flex
  justify-content center
  align-items center
  .container
    transform-origin 0 0
    margin auto
    img
      //max-width 100%
      display block
      image-rendering pixelated
    .mask-panel
      position absolute
      top 0
      width 100%
      height 100%
      &.ignore
        pointer-events none
        .crop-box
          position absolute
          border 1px red solid
          margin -1px
          box-sizing content-box
          color white
          font-size 12px
        .main
          border 2px red solid
          padding 1px
          margin -3px
          background-color #0003
      svg
        width 100%
        height 100%
</style>
